import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from 'Components/Header';
import Footer from 'Components/Footer';
import CookieBanner from 'Components/CookieBanner';
import ScrollToTop from 'Components/ScrollToTop';

import '../utils/i18n';

import 'sanitize.css';
import './site.css';
import 'react-perfect-scrollbar/dist/css/styles.css';

function Layout({ children, data }) {
  return (
    <div>
      <Helmet
        title="Montadrill"
        meta={[
          { name: 'description', content: '' },
        ]}
      />
      <Header data={
        {
          navigation: data.texts.navigation,
          slogan_line1: data.texts.slogan_line1,
          slogan_line2: data.texts.slogan_line2,
          facebook: data.texts.facebook,
          instagram: data.texts.instagram,
          headerImage: data.headerImage.childImageSharp,
        }}
      />
      <div
        className="wrapper mainContent"
      >
        {children()}
      </div>
      <Footer data={
        {
          name: data.texts.company_name,
          street: data.texts.street,
          postcode: data.texts.postcode,
          city: data.texts.city,
          phone: data.texts.contact_telephone,
          mail: data.texts.contact_email,
          facebook: data.texts.facebook,
          instagram: data.texts.instagram,
          mapTitle: data.texts.map_title,
          longitude: data.texts.map_longitude,
          latitude: data.texts.map_latitude,
        }}
      />
      <CookieBanner />
      <ScrollToTop />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.func.isRequired,
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
};

export default Layout;

export const indexPageQuery = graphql`

  query layoutQuery {
      
    texts: regionCommon {
      company_name
      street
      postcode
      city

      contact_email
      contact_telephone
      facebook
      instagram

      map_title
      map_latitude
      map_longitude

      slogan_line1
      slogan_line2
      
      navigation {
        navigation {
        	name
        	target
        }
      }
    }
    
    headerImage: file(relativePath: {eq: "assets/images/slider_headerbild.jpg"}) {
      id
      childImageSharp {
        sqip(numberOfPrimitives: 50, blur: 5, width: 400) {
          dataURI
        }
        sizes(
          grayscale: true, 
          maxWidth: 2500, 
          traceSVG: {optTolerance: 10, blackOnWhite: true},
        ) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js